import crudHandlers from "./_crud";

const initialState = {
    checksData: null,
    entities: [],
    is_fetching: false,
}

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {

        case 'REL_COMMUNICATION_COMPANY_GET_CHECKS':
            return {
                ...state,
                checksData: payload,
                is_fetching: false,
            }

        default:
            state = crudHandlers(state, action, 'rel_communication_company')
            return state
    }
}